<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '供应商信息' : '供应商信息'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-descriptions title="基本信息">
				<el-descriptions-item label="公司名称">{{item.company_name}}</el-descriptions-item>
				<el-descriptions-item label="公司地址">{{item.address}}</el-descriptions-item>
				<el-descriptions-item label="法人姓名">{{item.legal_person}}</el-descriptions-item>
				<el-descriptions-item label="法人联系方式">{{item.link_phone}}</el-descriptions-item>
				<el-descriptions-item label="法人身份证号">{{item.id_card}}</el-descriptions-item>
				<el-descriptions-item label="营业执照编号">{{item.license_number}}</el-descriptions-item>
				<el-descriptions-item label="法人身份证" :span="1">
					<img class="image" height="100px" style="max-width: 400px" :src="item.id_card_image" >
				</el-descriptions-item>
				<br>
				<el-descriptions-item label="营业执照" :span="1">
					<img class="image" height="100px" style="max-width: 400px" :src="item.license_image" >
				</el-descriptions-item>
				<br>
				<el-descriptions-item label="食品许可证" :span="1">
					<img class="image" height="100px" style="max-width: 400px" :src="item.food_license" >
				</el-descriptions-item>
				<br>
				<el-descriptions-item label="开户许可证" :span="1">
					<img class="image" height="100px" style="max-width: 400px" :src="item.open_license" >
				</el-descriptions-item>
				<br>
				<el-descriptions-item label="logo" :span="1">
					<img class="image" height="100px" style="max-width: 400px" :src="item.logo" >
				</el-descriptions-item>

				<el-descriptions-item label="品牌授权信息" :span="3">
					<img class="image" height="100px" style="max-width: 400px" :src="item.brand_authorizing" >
				</el-descriptions-item>

				<el-descriptions-item label="简介" :span="3">
					<div class="" v-html="item.introduction"></div>
				</el-descriptions-item>
			</el-descriptions>
			<el-form-item v-if="item.auth_status == 10" style="width: 100%" v-auth="['admin/supplier/audit']">
				<el-popconfirm title="您确定要通过这条数据吗？" @confirm="agree">
					<el-button size="big" type="primary" slot="reference">通过</el-button>
				</el-popconfirm>
				<el-button size="big" type="danger" @click="refuse" class="l10" style="margin-left: 10px">拒绝</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				rules: {

				}
			}
		},
		created() {
			if (this.id) {
				this.loadData()
			}
		},
		methods: {
			loadData() {
				var _this = this
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.post('/admin/supplier/detail', {
					// 请求查询的数据 id为undefined的时候没有值
					id: this.id
				}).then(res => {
					_this.isLoad = false
					// item是基础信息
					_this.item = res.data.detail
					// this.item.password = ''
				}).catch(() => {
					_this.isLoad = false
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			agree: function () {
				this.axios.post('/admin/supplier/agree', {
					id: this.id
				})
				.then(() => {
					this.isLoad = false
					this.$message.success({
						message: '审核成功'
					});
					this.goBack()
				})
				.catch(() => {
					this.isLoad = false
				})
			},
			refuse: function () {
				this.$prompt('', '拒绝原因', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({ value }) => {
					if (value == '') {
						this.$message.success({
							message: '请输入拒绝原因'
						});
						return
					}
					if(this.isLoad){
						return
					}
					this.isLoad = !this.isLoad
					this.axios.post('/admin/supplier/refuse', {
						id: this.id,
						memo: value
					})
					.then(() => {
						this.isLoad = false
						this.$message.success({
							message: '审核成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = false
					})
				}).catch(() => {

				});
			}
		}
	}
</script>
<style scoped>
</style>
